import { render } from "./CentralBar.vue?vue&type=template&id=7151e2a0"
import script from "./CentralBar.vue?vue&type=script&lang=js"
export * from "./CentralBar.vue?vue&type=script&lang=js"

import "./CentralBar.vue?vue&type=style&index=0&id=7151e2a0&lang=css"

import exportComponent from "/home/vshemyatin/phonebook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__